<template>
  <b-modal :id="modalId" :title="title" hide-footer no-close-on-backdrop>
    <b-tabs content-class="mt-3" v-if="selectedMachineUser">
      <b-tab title="Profile" active>
        <div class="tab-box">
          <profile-row heading="DESCRIPTION" :info="selectedMachineUser.description" />
          <profile-row heading="CLIENT ID" :info="selectedMachineUser.client_id" />
          <profile-row heading="ORGANIZATION" v-if="selectedOrganization" :info="selectedOrganization.name" />
          <profile-row heading="GROUP" v-if="selectedMachineUser.group" :info="selectedMachineUser.group.name" />
          <profile-row heading="ROLE" v-if="selectedMachineUser" info="Machine" />
          <profile-row heading="ACTIVATION" v-if="canActivateUser">
            <template v-slot:info-slot>
              <activation-toggle :activationStatus="selectedMachineUser.is_active"
                :isLoading="isTogglingActivation"
                @toggleActivation="toggleActivation" />
            </template>
          </profile-row>
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import config from '../../constants/config';
import { mapGetters } from 'vuex';
import ActivationToggle from '../Inputs/ActivationToggle.vue';
import ProfileRow from '../ProfileRow.vue';

export default {
  name: 'MachineUserModal',
  components: {
    ProfileRow,
    ActivationToggle
  },
  data() {
    return {
      isTogglingActivation: false
    }
  },
  methods: {
    async toggleActivation() {
      this.isTogglingActivation = true;

      const success = await this.$store.dispatch('user/toggleActivationMachineUser', this.selectedMachineUser);
      if (success) {
        this.hasUpdate();
      }

      this.isTogglingActivation = false;
    },
    hasUpdate() {
      this.$emit('hasUpdate');
    }
  },
  computed: {
    ...mapGetters('user', ['selectedMachineUser', 'user']),
    ...mapGetters('organization', ['selectedOrganization']),
    modalId() {
      return config.MACHINE_USER_MODAL_ID;
    },
    title() {
      return this.selectedMachineUser ? this.selectedMachineUser.decsription : "";
    },
    canActivateUser() {
      const allowed = [
        config.SUPERUSER,
        config.STAFF_USER,
        config.PARTNER,
        config.MANAGER,
        config.MEMBER,
      ];
      return this.user && allowed.includes(this.user.role.id);
    },
  }
};
</script>
